import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";

axios.defaults.baseURL = process.env.REACT_APP_API_URL;

export const createPhysioServiceSlice = createAsyncThunk(
  "physioServiceMaster/createPhysiotherapyServiceMaster",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        "/physioServiceMaster/createPhysiotherapyServiceMaster",
        data,
        {
          headers: {
            "Content-Type": "application/json",
            token: data.token,
          },
        }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

export const getPhysioServiceSlice = createAsyncThunk(
  "physioServiceMaster/getPhysiotherapyServiceMaster",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        "/physioServiceMaster/getPhysiotherapyServiceMaster",
        data,
        {
          headers: {
            "Content-Type": "application/json",
            token: data.token,
          },
        }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

export const updatePhysioServiceMaster = createAsyncThunk(
  "physioServiceMaster/updatePhysiotherapyServiceMaster",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.put(
        "/physioServiceMaster/updatePhysiotherapyServiceMaster",
        data,
        {
          headers: {
            "Content-Type": "application/json",
            token: data.token,
          },
        }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

export const deletePhysioServiceMaster = createAsyncThunk(
  "physioServiceMaster/deletePhysiotherapyServiceMaster",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.put(
        "/physioServiceMaster/deletePhysiotherapyServiceMaster",
        data,
        {
          headers: {
            "Content-Type": "application/json",
            token: data.token,
          },
        }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);
export const getPhysiotherapyServiceById = createAsyncThunk(
  "physioServiceMaster/getPhysiotherapyServiceId",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        "/physioServiceMaster/getPhysiotherapyServiceId",
        data,
        {
          headers: {
            "Content-Type": "application/json",
            token: data.token,
          },
        }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);
const initialState = {
  loading: false,
  physiotherapyServices: [],
  physiotherapyServiceById: [],
  createPhysiotherapyServiceSuccessMessage: null,
  createPhysiotherapyServiceErrorMessage: null,
  searchMessage: null,
  updatePhysiotherapyServiceSuccessMessage: null,
  updatePhysiotherapyServiceErrorMessage: null,
  deletePhysiotherapyServiceSuccessMessage: null,
  deletePhysiotherapyServiceErrorMessage: null,
  currentPage: 1,
  totalPages: null,
  hasMore: true,
  totalCount: 0,
};

const physiotherapyServiceSlice = createSlice({
  name: "physiotherapyServiceMaster",
  initialState,
  reducers: {
    resetCreatePhysiotherapyServiceMessage: (state) => {
      state.createPhysiotherapyServiceSuccessMessage = null;
      state.createPhysiotherapyServiceErrorMessage = null;
    },
    resetUpdatePhysiotherapyServiceMessage: (state) => {
      state.updatePhysiotherapyServiceSuccessMessage = null;
      state.updatePhysiotherapyServiceErrorMessage = null;
    },
    resetDeletePhysiotherapyServiceMessage: (state) => {
      state.deletePhysiotherapyServiceSuccessMessage = null;
      state.deletePhysiotherapyServiceErrorMessage = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(createPhysioServiceSlice.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(createPhysioServiceSlice.fulfilled, (state, action) => {
        state.loading = false;
        if (action.payload.success === false) {
          state.createPhysiotherapyServiceErrorMessage =
            action.payload.result.message;
        } else {
          state.createPhysiotherapyServiceSuccessMessage =
            action.payload.result.message;
        }
      })
      .addCase(createPhysioServiceSlice.rejected, (state, action) => {
        state.loading = false;
        state.createPhysiotherapyServiceErrorMessage = action.payload;
      })
      .addCase(getPhysioServiceSlice.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(getPhysioServiceSlice.fulfilled, (state, action) => {
        state.loading = false;
        if (!action.payload.success) {
          state.physiotherapyServices = [];
          state.totalCount = 0;
          state.totalPages = 1;
          state.searchMessage =
            action.payload.result?.message || "No data found";
          return;
        }
        const result = action.payload.result;
        state.physiotherapyServices = result.list || [];
        state.currentPage = Number(result.currentPage) || 1;
        state.totalPages = Number(result.totalPages) || 1;
        state.totalCount = Number(result.totalRecords) || 0;
        state.hasMore = result.hasMore ?? false;
        state.searchMessage = null;
      })
      .addCase(getPhysioServiceSlice.rejected, (state, action) => {
        state.loading = false;
      })
      .addCase(updatePhysioServiceMaster.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(updatePhysioServiceMaster.fulfilled, (state, action) => {
        state.loading = false;
        if (action.payload.success === false) {
          state.updatePhysiotherapyServiceErrorMessage =
            action.payload.result.message;
        } else {
          state.updatePhysiotherapyServiceSuccessMessage =
            action.payload.result.message;
        }
      })
      .addCase(updatePhysioServiceMaster.rejected, (state, action) => {
        state.loading = false;
        state.updatePhysiotherapyServiceErrorMessage = action.payload;
      })
      .addCase(deletePhysioServiceMaster.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(deletePhysioServiceMaster.fulfilled, (state, action) => {
        state.loading = false;
        if (action.payload.success === false) {
          state.deletePhysiotherapyServiceErrorMessage =
            action.payload.result.message;
        } else {
          state.deletePhysiotherapyServiceSuccessMessage =
            action.payload.result.message;
        }
      })
      .addCase(deletePhysioServiceMaster.rejected, (state, action) => {
        state.loading = false;
        state.deletePhysiotherapyServiceErrorMessage = action.payload;
      })
      .addCase(getPhysiotherapyServiceById.pending, (state) => {
        state.loading = true;
      })
      .addCase(getPhysiotherapyServiceById.fulfilled, (state, action) => {
        state.loading = false;
        if (action.payload.success === false) {
          state.searchMessage = action.payload.result.message;
        }
        state.physiotherapyServiceById = action.payload.result.list;
      })
      .addCase(getPhysiotherapyServiceById.rejected, (state, action) => {
        state.loading = false;
      });
  },
});

export const {
  resetCreatePhysiotherapyServiceMessage,
  resetUpdatePhysiotherapyServiceMessage,
  resetDeletePhysiotherapyServiceMessage,
} = physiotherapyServiceSlice.actions;
export default physiotherapyServiceSlice.reducer;
